import { useQuery } from "@tanstack/react-query"
import { changeLogQuery } from "../lib/changeLogQuery"

export function useChangeLogQuery(...args: Parameters<typeof changeLogQuery>) {
  return useQuery(changeLogQuery(...args))
}
